(function() {

    var html = `
    <ul><!--
        --><li class="politics"><a class="politics" href="http://www.realclearpolitics.com">Politics</a></li><!--
        --><li class="policy"><a class="policy" href="http://www.realclearpolicy.com">Policy</a></li><!--
        --><li class="markets"><a class="markets" href="http://www.realclearmarkets.com">Markets</a></li><!--
        --><li class="world"><a class="world" href="http://www.realclearworld.com">World</a></li><!--
        --><li class="defense"><a class="defense" href="http://www.realcleardefense.com">Defense</a></li><!--
        --><li class="energy"><a class="energy" href="http://www.realclearenergy.org">Energy</a></li><!--
        --><li class="health"><a class="health" href="http://www.realclearhealth.com">Health</a></li><!--
        --><li class="science"><a class="science" href="http://www.realclearscience.com">Science</a></li><!--
        --><li class="religion"><a class="religion" href="http://www.realclearreligion.org">Religion</a></li><!--
        --><li class="investigations"><a class="investigations" href="https://www.realclearinvestigations.com/">Investigations</a></li><!--
        --><li class="education"><a class="education" href="http://www.realcleareducation.com">Education</a></li><!--
        --><li class="foundation"><a class="foundation" href="https://www.realclearfoundation.com">Foundation</a></li><!--
        --><li class="history"><a class="history" href="http://www.realclearhistory.com">History</a></li><!--
        --><li class="books"><a class="books" href="http://www.realclearbooks.com">Books & Culture</a></li><!--
        --><li class="life"><a class="life" href="http://www.realclearlife.com">Life</a></li><!--
    --></ul>
    `;

    // Replace HTML content of all matching targets with above
    var containers = document.querySelectorAll('.footer .footer-links');
    if(containers.length > 0) {
        for(var i = 0; i < containers.length; i++) {
            containers[i].innerHTML = html;
        }
    }

    html = `
    <ul>
        <li><a href="/about.html">About Us</a></li>
        <li><a href="/privacy.html">Privacy Policy</a></li>
        <li><a href="/media_kit/contact_us.html">Advertise With Us</a></li>
        <li><a href="/contact.html">Contact</a></li>
        <li><a href="/rss">RSS</a></li>
        <li class="view-mobile"><a onClick="loadMobile();">View Mobile Site</a></li>
    </ul>
    <div class="clear"></div>
    <center><a href="/copyright.html" class="copyright-button">Copyright &copy; `+(new Date().getFullYear())+` RealClearHoldings, LLC.</a> <br/><a href="javascript:void(0)" class="ccpaOptOut" style="display:none; padding:10px 0 0 0; cursor:pointer;">Do Not Sell My Personal Information</a></center>
    `;

    // Replace HTML content of all matching targets with above
    var containers = document.querySelectorAll('.footer .footer-info .info-links');
    if(containers.length > 0) {
        for(var i = 0; i < containers.length; i++) {
            containers[i].innerHTML = html;
        }
    }

})();